import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { APP_FULL_PATHS } from '../../shared/constants/routes.constants';
import { TokenService } from '../services/token.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const tokenService = inject(TokenService);

  const isAuthRoute =
    req.url.includes(APP_FULL_PATHS.LOGIN) || req.url.includes(APP_FULL_PATHS.SIGNUP);
  const token = tokenService.getAccessToken();

  const authReq =
    token && !isAuthRoute ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isAuthRoute) {
        tokenService.clearTokens();
        router.navigate([APP_FULL_PATHS.LOGIN]);
      }
      return throwError(() => error);
    }),
  );
};
